import CKEditor from "@/components/ckeditor/CKEditor"
import { ref, toRef } from "vue"
import { defineComponent, inferProps, refSetter, type ReactiveComponent } from "vue-utils"
import { useIncidentHandler } from "../../../IncidentLogHandler"
import EditValueModal from "../EditValueModal"
import { useWatchExternalChanges } from "../useWatchChanges"

interface Props {
	instructions: string

	cancel(): void
	setInstructions(instructions: string): Promise<void>
}

const EditTaskingInstructions: ReactiveComponent<Props> = (props) => {
	const handler = useIncidentHandler()
	const instructions = ref(props.instructions)

	useWatchExternalChanges({
		name: "Tasking Instructions",
		currentValue: instructions,
		globalValue: toRef(props, "instructions"),
	})

	return () => (
		<EditValueModal
			title={handler.readOnly ? "View Tasking Instructions " : "Edit Tasking Instructions"}
			cancel={props.cancel}
			save={() => props.setInstructions(instructions.value)}
			style={{ width: "64rem" }}
		>
			<div style={{ minHeight: "20rem" }}>
				<CKEditor
					class="w-full"
					value={instructions.value}
					setValue={refSetter(instructions)}
					height="16rem"
					readOnly={handler.readOnly}
					viewOnly={handler.readOnly}
				/>
			</div>
		</EditValueModal>
	)
}

export default defineComponent(EditTaskingInstructions, inferProps<Props>())
